<template>
  <v-container>
    <v-card class="px-2">
      <v-form>
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              outlined
              dense
            >
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="success"
                tile
                @click.prevent="loadDialog"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            md="3"
            sm="6"
            v-if="view.id"
          >
            <v-checkbox
              v-model="view.inativar"
              label="Ativar view?"
              color="success"
              class="mt-3 mv-3"
            ></v-checkbox>
          </v-col>
        </v-row>
        <form-view
          :view="view"
          :dsView="dsView"
          :parent="parent"
          :path="path"
          :menus="menus"
          @load-menus="loadMenus"
          @load-menu-id="loadMenuId"
        />
      </v-form>
      <v-card-actions class="justify-start">
        <v-btn
          color="success"
          class="ml-1 mr-4"
          v-if="!view.id"
          @click.prevent="save"
        >
          <v-icon left>
            mdi-content-save-outline
          </v-icon>
          Salvar
        </v-btn>
        <v-btn
          color="success"
          class="ml-1 mr-4"
          v-if="view.id"
          @click.prevent="save"
        >
          <v-icon left>
            mdi-content-save-edit-outline
          </v-icon>
          Atualizar
        </v-btn>
        <v-btn
          color="secondary"
          class="mr-4"
          @click="reset()"
        >
          <v-icon left>
            mdi-broom
          </v-icon>
          Limpar
        </v-btn>
        <v-btn
          v-if="view.id"
          color="error"
          class="mr-4"
          @click="remove"
        >
          <v-icon left>
            mdi-trash-can-outline
          </v-icon>
          Deletar
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- Dialog de filtro de galerias -->
    <v-container>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar galerias
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headerView"
              :items="views"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadUpdate(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </v-container>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import formView from '../../components/forms/formView.vue'
export default {
  components: { formView },
  name: 'FormViews',
  computed: mapState(['user']),

  data: () => ({
    codigo: '',
    dialog: false,
    dsView: '',
    search: '',
    view: {},
    path: {},
    menus: [],
    parent: [],
    views: [],
    headerView: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'View', value: 'view' },
      { text: 'Nome', value: 'ds_view' },
      { text: 'Grupo', value: 'uid_grupo' },
      { text: 'Menu', value: 'uid_menu' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  mounted () {
    this.loadUser()
    this.loadParent()
  },
  methods: {
    save () {
      const method = this.view.id ? 'put' : 'post'
      const id = this.view.id ? `/${this.view.id}` : ''
      axios[method](`${baseApiUrl}/views-dos-modulos${id}`, this.view)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    remove () {
      const id = this.view.id
      if (confirm('Deseja realmente deletar esta view?')) {
        axios.delete(`${baseApiUrl}/galeriass/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    loadDialog () {
      this.dialog = true
      this.view = {}
      this.codigo = ''
      this.loadViews()
    },
    loadUpdate (item) {
      const id = item.id
      const url = `${baseApiUrl}/views-dos-modulos/${id}`
      axios.get(url).then(res => {
        this.view = res.data
        this.dsView = this.view.ds_view
        this.codigo = this.view.id
        const uid = this.view.uid_grupo
        this.loadMenus(uid)
      })
      this.dialog = false
    },
    loadViews () {
      const url = `${baseApiUrl}/views-dos-modulos-filtro`
      axios.get(url).then(res => {
        this.views = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadMenuId () {
      const id = this.view.uid_menu
      const url = `${baseApiUrl}/menu-sys/${id}`
      axios.get(url).then(res => {
        this.path = res.data
        this.dsView = this.path.nome
        this.view.ds_view = this.path.nome
      })
      //  this.$emit('set-evento')
      // this.$emit("emit-fornec", Dados);
    },
    loadMenus (uid) {
      const id = uid
      const url = `${baseApiUrl}/menus-por-grupo-de-programas/${id}`
      axios.get(url).then(res => {
        this.menus = res.data.map(item => {
          return {
            value: item.id,
            text: item.nome
          }
        })
      })
    },
    loadParent () {
      const url = `${baseApiUrl}/menu-sys-admin`
      axios.get(url).then(res => {
        this.parent = res.data.map(parent => {
          return {
            value: parent.id,
            text: parent.nome
          }
        })
      })
      this.dsView = ''
    },
    reset () {
      this.dsView = ''
      this.view = {}
      this.path = {}
      this.menus = []
      this.codigo = ''
      this.loadUser()
    },
    loadUser () {
      this.view.usuario = this.user.id
    }
  }
}
</script>
<style scoped>
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
</style>
